// Conteúdo central da página. Itens marcados com TODO(Paulo) precisam ser
// confirmados/preenchidos com o cliente antes de divulgar em anúncios.

export const WHATSAPP_NUMBER = '5511981850864';
export const WHATSAPP_DISPLAY = '(11) 98185-0864';
export const INSTAGRAM_URL = 'https://www.instagram.com/someluzoficial/';
export const INSTAGRAM_HANDLE = '@someluzoficial';

// TODO(Paulo): confirmar área de atendimento.
export const REGION = 'São Paulo e região';

// Rótulo único para a intenção "pedir orçamento" em toda a página.
export const CTA_LABEL = 'Pedir orçamento';

export const quoteMessage = (eventType = '') =>
  'Olá, Paulo! Vim pelo site e quero um orçamento.\n\n' +
  `Tipo de evento: ${eventType}\nData: \nLocal/cidade: \nNº de convidados: `;

export const IMAGES = {
  paulo: { src: '/img/evento-externo.webp', alt: 'DJ Paulo na cabine de som durante um evento ao ar livre' },
  crowd: { src: '/img/pista-cheia.webp', alt: 'Festa ao ar livre lotada vista da cabine do DJ' },
  booth: { src: '/img/equipamento.webp', alt: 'Controladora do DJ com luzes coloridas na pista' },
  setup: { src: '/img/dj-paulo.webp', alt: 'DJ Paulo de costas, com a camiseta da Atitude Som e Luz, preparando o som' },
  // TODO(Paulo): enviar fotos e vídeos de casamentos, 15 anos e eventos corporativos.
};

export const events = [
  {
    id: 'casamento',
    title: 'Casamentos',
    text: 'Da entrada dos noivos à última música, com roteiro combinado antes.',
    message: 'Casamento',
  },
  {
    id: 'aniversario',
    title: 'Aniversários e 15 anos',
    text: 'Repertório pensado para a idade do aniversariante e dos convidados.',
    message: 'Aniversário / 15 anos',
    image: 'setup',
  },
  {
    id: 'flashback',
    title: 'Festas flashback',
    text: 'A especialidade da casa: anos 70, 80 e 90 do jeito que a pista pede.',
    message: 'Festa flashback',
    image: 'booth',
  },
  {
    id: 'corporativo',
    title: 'Eventos corporativos',
    text: 'Confraternizações, lançamentos e festas de fim de ano com som e luz sob controle.',
    message: 'Evento corporativo',
    image: 'crowd',
  },
];

export const differentials = [
  {
    title: 'Lê a pista em tempo real',
    text: 'Paulo observa quem dança e quem ficou sentado, e muda o rumo antes da festa esfriar.',
  },
  {
    title: 'Uma música para cada geração',
    text: 'Flashback dos anos 70, 80 e 90 misturado com o que toca hoje. Avós e amigos na mesma pista.',
  },
  {
    title: 'DJ, som e luz em um contrato',
    text: 'Um fornecedor só para o que faz a festa acontecer. Menos gente para coordenar no dia.',
  },
  {
    // TODO(Paulo): confirmar que não envia DJ substituto.
    title: 'Quem você contrata é quem toca',
    text: 'O Paulo está na cabine do começo ao fim do seu evento.',
  },
];

// Depoimentos reais recebidos pelo cliente.
// TODO(Paulo): pedir nome e tipo de evento de cada um (e print, se possível).
export const testimonials = [
  { text: 'O melhor DJ de todos! Superou todas as minhas expectativas. Recomendo muito!', author: 'Letícia Borges', role: 'Cliente' },
  { text: 'Super indico de olhos fechados. O melhor DJ que já contratei para meus eventos!', author: 'Cliente', role: null },
  { text: 'Melhor seleção musical! Cada música foi perfeita para o momento.', author: 'Cliente', role: null },
  { text: 'Excelente trabalho! Todos os meus convidados adoraram a festa!', author: 'Cliente', role: null },
  { text: 'Energia incrível do início ao fim, festa memorável!', author: 'Cliente', role: null },
];

// TODO(Paulo): preencher `price` com o valor "a partir de" (ex.: 'R$ 1.800') e
// confirmar itens de cada pacote. Enquanto `price` for null, mostra "Sob consulta".
export const packages = [
  {
    id: 'completo',
    name: 'Completo',
    fit: 'Casamentos, 15 anos e festas que pedem pista de verdade.',
    price: null,
    featured: true,
    items: [
      'DJ Paulo e som profissional',
      'Iluminação de pista',
      'Roteiro dos momentos principais',
      'Microfone para discursos',
      'Repertório combinado antes do evento',
    ],
  },
  {
    id: 'essencial',
    name: 'Essencial',
    fit: 'Aniversários, confraternizações e eventos menores.',
    price: null,
    items: ['DJ Paulo e som profissional', 'Repertório combinado'],
  },
  {
    id: 'premium',
    name: 'Premium',
    fit: 'Eventos grandes e corporativos que querem cenário.',
    price: null,
    items: ['Tudo do Completo', 'Iluminação decorativa e cênica', 'Horas extras sob medida'],
  },
];

export const steps = [
  { title: 'Conte sobre o evento', text: 'Tipo, data, cidade e número de convidados. Pelo WhatsApp ou pelo formulário.' },
  { title: 'Receba o orçamento', text: 'O Paulo confirma a data e monta a proposta com o formato ideal.' },
  { title: 'Aproveite a festa', text: 'Som e luz montados antes dos convidados chegarem. A pista fica com ele.' },
];

// TODO(Paulo): revisar todas as respostas antes de publicar.
export const faq = [
  {
    q: 'Posso escolher as músicas?',
    a: 'Sim. Você manda as que não podem faltar e as que não podem tocar. O Paulo monta o repertório em volta disso e ajusta ao vivo.',
  },
  {
    q: 'Toca flashback e música atual na mesma festa?',
    a: 'Toca, e essa mistura é a especialidade da casa: flashback para quem viveu a época, hits atuais para os mais novos.',
  },
  {
    q: 'Vocês atendem na minha cidade?',
    a: `Atendemos ${REGION}. Para outras cidades, mande o local pelo WhatsApp e o Paulo informa se há taxa de deslocamento.`,
  },
  {
    q: 'Com quanta antecedência preciso reservar?',
    a: 'Sábados costumam fechar primeiro. Consultar cedo não gera compromisso e aumenta a chance da data estar livre.',
  },
  {
    q: 'Atendem empresas com nota fiscal?',
    // TODO(Paulo): confirmar emissão de nota fiscal / contrato para PJ.
    a: 'Sim. Eventos corporativos recebem proposta formal e contrato.',
  },
  {
    q: 'E se algum equipamento der problema no dia?',
    // TODO(Paulo): confirmar política de equipamento reserva.
    a: 'O Paulo leva equipamento reserva para os itens essenciais de som, para a festa não parar.',
  },
];

export const eventTypes = ['Casamento', 'Aniversário / 15 anos', 'Festa flashback', 'Evento corporativo', 'Outro'];
export const guestRanges = ['Até 80', '80 a 150', '150 a 250', 'Mais de 250'];
